export { default } from './CmsPartialSsr.vue';
